module.exports = function getResource(label, vars = []) {
    const resources = { freeShippingMessage: `Plus que ${vars[0]} pour avoir droit à la livraison gratuite.` };

    return resources[label];
};
